import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { DocumentTagsService } from '../document-tags.service';
import { DocumentTagsAddPayload } from '../document-tags.interface';

@Component({
    selector: 'app-add-document-tags',
    templateUrl: './add-document-tags.component.html',
    styleUrls: ['./add-document-tags.component.scss']
})
export class AddDocumentTagsComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        // slug: new FormControl('', []),
        description: new FormControl('', []),
        color: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddDocumentTagsComponent>,
        private requestService: DocumentTagsService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, description, color } = this.form
            .value as DocumentTagsAddPayload;
        const payload: DocumentTagsAddPayload = {
            name,
            description,
            color
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
